// extracted by mini-css-extract-plugin
module.exports = {"content":"content--54f8e","icon":"icon--8212d"};